'use client'

import { useEffect, useRef } from 'react'
import Link from 'next/link'

// Расширяем типы для WhatConverts
declare global {
  interface Window {
    $wc_leads?: any
  }
}

interface PhoneSyncProps {
  phoneNumber: string
}

export default function PhoneSync({ phoneNumber }: PhoneSyncProps) {
  const phoneLinkRef = useRef<HTMLAnchorElement>(null)
  const phoneTextRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    // Функция для синхронизации телефона с хедером
    const syncPhoneWithHeader = () => {
      try {
        // Находим телефон в хедере - ищем более точно
        const headerPhone = document.querySelector('nav a[href^="tel:"]') || 
                           document.querySelector('header a[href^="tel:"]') ||
                           document.querySelector('a[href^="tel:"]')
        
        if (headerPhone) {
          const headerPhoneNumber = headerPhone.getAttribute('href')?.replace('tel:', '')
          const headerPhoneText = headerPhone.textContent?.trim()
          
          // Если телефон в хедере отличается от телефона в футере
          if (headerPhoneNumber && 
              headerPhoneNumber !== phoneNumber && 
              phoneLinkRef.current && 
              phoneTextRef.current &&
              headerPhoneNumber.length > 0) {
            
            // Обновляем ссылку и текст телефона в футере
            phoneLinkRef.current.href = `tel:${headerPhoneNumber}`
            phoneTextRef.current.textContent = headerPhoneText || headerPhoneNumber
            
            console.log('FooterNonAnimated: Phone synchronized with header', {
              headerPhone: headerPhoneNumber,
              footerPhone: phoneNumber
            })
          }
        }
      } catch (error) {
        console.error('FooterNonAnimated: Error syncing phone with header:', error)
      }
    }

    // Запускаем синхронизацию после полной загрузки страницы
    const timer1 = setTimeout(syncPhoneWithHeader, 1000)
    
    // Дополнительная проверка через 3 секунды (на случай если WhatConverts загружается медленно)
    const timer2 = setTimeout(syncPhoneWithHeader, 3000)
    
    // Проверка после загрузки WhatConverts (если он есть)
    const checkWhatConverts = () => {
      if (window.$wc_leads || document.querySelector('script[src*="whatconverts"]')) {
        setTimeout(syncPhoneWithHeader, 500)
      }
    }
    
    // Проверяем каждые 2 секунды в течение 10 секунд
    const whatConvertsTimer = setInterval(checkWhatConverts, 2000)
    const stopWhatConvertsCheck = setTimeout(() => clearInterval(whatConvertsTimer), 10000)

    // Также запускаем при изменении DOM (на случай если WhatConverts обновит телефон позже)
    const observer = new MutationObserver((mutations) => {
      // Проверяем только если изменения касаются текста или атрибутов
      const hasRelevantChanges = mutations.some(mutation => 
        mutation.type === 'characterData' || 
        (mutation.type === 'attributes' && mutation.attributeName === 'href') ||
        (mutation.type === 'childList' && mutation.target.nodeType === Node.ELEMENT_NODE)
      )
      
      if (hasRelevantChanges) {
        syncPhoneWithHeader()
      }
    })

    // Наблюдаем за изменениями в хедере
    const header = document.querySelector('nav') || document.querySelector('header')
    if (header) {
      observer.observe(header, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['href']
      })
    }

    return () => {
      clearTimeout(timer1)
      clearTimeout(timer2)
      clearInterval(whatConvertsTimer)
      clearTimeout(stopWhatConvertsCheck)
      observer.disconnect()
    }
  }, [phoneNumber])

  return (
    <Link
      ref={phoneLinkRef}
      href={`tel:${phoneNumber}`}
      className='text-white hover:text-gray-200'
    >
      <span ref={phoneTextRef}>
        {phoneNumber}
      </span>
    </Link>
  )
} 